import { connect } from 'react-redux';
import FooterPoweredBy from '../components/footer-powered-by';

const mapStateToProps = ({ purchases }) => {
  const purchase = purchases.byId[purchases.current];
  const { displayName, logoUrl } = purchase.merchant;

  return {
    displayName,
    logoUrl,
  };
};

export default connect(mapStateToProps)(FooterPoweredBy);




// WEBPACK FOOTER //
// ./src/desktop/containers/footer-powered-by.container.js